import React, { useState, useEffect } from "react";

// core
import { API } from "../../core/api";
import { getSiteName } from "../../core/utils";

// components
import { Header } from "../../components/Header";
import { SiteSellerProducts } from "./SiteSellerProducts";
import { Tabs } from "antd";
import { Note } from "../../components/Note";

const { TabPane } = Tabs;

export const Sites = () => {
  const [sites, setSites] = useState([]);

  const getSites = () => {
    // API.get
    //   .sites(true)
    //   .then((response) => {
    //     if (response.success) {
    //       setSites(response.data);
    //     } else {
    //       Note.error(response.message);
    //     }
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });
  };

  useEffect(() => {
    getSites();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Header title="فروشگاه‌ها" activeItem="sites" />
      <div className="product-page">
        <Tabs size="small">
          {sites?.map((site) => (
            <TabPane
              tab={`فروشگاه ${getSiteName(site.name)}`}
              key={`2${site.id}`}
            >
              <SiteSellerProducts site={site} />
            </TabPane>
          ))}
        </Tabs>
      </div>
    </>
  );
};
